<template>

    <div>
        <a-modal
            :title="modalState.title"
            :visible="modalState.visible"
            :confirm-loading="confirmLoading"
            width="900px"
            @cancel="handleCancel"
        >
            <a-form-model
                :model="modalState.menuData"
                ref="ruleForm"
                :rules="rules"
                :layout="formItemLayout"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
            >
                <a-form-model-item ref="name" label="权限/菜单名" prop="name">
                    <a-input
                        v-model="modalState.menuData.name"
                        aria-placeholder="请输入权限/菜单名"
                        @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>
                <a-form-model-item ref="name" label="子名称" prop="subname">
                    <a-input
                        v-model="modalState.menuData.subname"
                        aria-placeholder="请输入子名称"
                        @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>


                <a-form-model-item label="菜单类型">
                    <a-select v-model="modalState.menuData.type" placeholder="请选择菜单" prop="type" @change="typeOnChange"
                              style="width: 85%">
                        <a-select-option value="0">菜单</a-select-option>
                        <a-select-option value="1">权限</a-select-option>
                        <a-select-option value="2">复杂菜单</a-select-option>
                        <a-select-option value="3">复杂权限</a-select-option>
                    </a-select>
                    <a-popover title="菜单类型" style="width: 8%">
                        <template slot="content">
                            <p>选项类型分普通类型（菜单、权限）与复杂类型（复杂菜单、复杂权限）</p>
                            <p>普通类型为字符串类型，复杂类型为Map类型,key为appcode,value为url</p>
                            <p>例如：普通类型（/user/list）,复杂类型：(cloudpos_h5:/syjuser/list ,lingshou_pc:)</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;"/>
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="url" label="路径URL" prop="url">
                    <a-input
                        v-if="modalState.menuData.type==0||modalState.menuData.type==1"
                        v-model="modalState.menuData.url"
                        aria-placeholder="请输入URL"
                        @blur="() => {$refs.url.onFieldBlur();} "
                    />
                    

                    <div v-if="modalState.menuData.type==2||modalState.menuData.type==3">
                        <a-button type="dashed"
                              style="width: 60%"
                              @click="addMenu">
                                <a-icon type="plus"/>
                                添加配置
                         </a-button>
                        <div  v-for="(urlItem) in urlMap" :key="urlItem.name">
                            <!--                    {{ k.name }}{{ k.value }}-->
                            <a-select v-model="urlItem.name" class="urlItemInput" placeholder="请选择">
                                <a-select-option v-for="(item,index) in urlConfigList" :disabled="urlMap.filter(fitem => {return fitem.name == item.name}).length > 0"  :key="index"
                                    v-model="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                            <label style="width:10px;text-align:center;padding:0 5px;">:</label>
                            <a-input v-model="urlItem.value" class="urlItemInput"/>
                            <a-icon style="width: 20px;margin-left:8px" class="dynamic-delete-button" type="minus-circle-o"
                                    @click="() => remove(urlItem)"/>
                        </div>
                    </div>
                </a-form-model-item>
                <a-form-model-item ref="menucode" label="菜单编码" prop="menucode">

                    <a-input-search
                        v-if="(!modalState.menuData.id) && (modalState.menuData.id <= 0 || isEditblleMenucode == '') "
                        v-model="modalState.menuData.menucode"
                        enter-button="生成编码"
                        @search="generateMenuCode"
                        @blur="
                    () => {
                        $refs.menucode.onFieldBlur();
                    }
                    "
                    />
                    <span class="form_span" v-else>{{ modalState.menuData.menucode }}</span>
                </a-form-model-item>

                <a-form-model-item ref="actionpath" label="后端action地址" prop="actionpath">
                    <a-input
                        v-if="modalState.menuData.type==0||modalState.menuData.type==1"
                        v-model="modalState.menuData.actionpath"
                        aria-placeholder="请输入action地址"
                        @blur="() => {$refs.actionpath.onFieldBlur();}"
                    />
                    <a-button v-if="modalState.menuData.type==2||modalState.menuData.type==3" type="dashed"
                              style="width: 60%"
                              @click="addAction">
                        <a-icon type="plus"/>
                        添加配置
                    </a-button>
                    <span v-if="modalState.menuData.type==2||modalState.menuData.type==3">
                    <MenuModal :menuModalStatus="actionModalStatus" @onModalHide="onNewActionConfig"></MenuModal>
                    <a-form-model-item v-for="(k, index) in modalState.actionpathMap" :key="index" >
                        <!--                    {{ k.name }}{{ k.value }}-->
                        <label style="width:50px">{{ k.name }}:</label>
                        <a-input v-model="k.value" style="width: 260px"/>
                        <a-icon style="width: 15px" class="dynamic-delete-button" type="minus-circle-o"
                                @click="() => removeAction(k)"/>
                    </a-form-model-item>
                    </span>
                </a-form-model-item>
                <a-form-model-item label="状态">
                    <a-select v-model="modalState.menuData.status" placeholder="使用" prop="status">
                        <a-select-option value="0">禁用</a-select-option>
                        <a-select-option value="1">使用</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item ref="remark" label="备注" prop="remark">
                    <a-input
                        v-model="modalState.menuData.remark"
                        aria-placeholder="请输入备注，例如：版本号v1  分支号0915"
                        @blur="
                        () => {
                            $refs.remark.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>
                <a-form-model-item ref="ordernum" label="排序" prop="ordernum">
                    <a-input
                        v-model="modalState.menuData.ordernum"
                        aria-placeholder="请输入排序号"
                    />
                </a-form-model-item>
                <a-form-model-item ref="icon" label="图标名" prop="icon">
                    <a-icon :type="modalState.menuData.icon" style="width: 10%"/>
                    <a-input style="width: 90%"
                             v-model="modalState.menuData.icon"
                             aria-placeholder="请输入图标名"
                    />
                </a-form-model-item>
                <a-form-model-item ref="hookconfig" label="自定义扩展" prop="hookconfig" style="margin-bottom:20px;">
                    <a-input style="width: 85%;"
                             v-model="modalState.menuData.hookconfig"
                             aria-placeholder="自定义扩展"
                    />
                    <a-popover title="自定义扩展" style="width: 8%;">
                        <template slot="content">
                            <p>此属性设置为接入的系统自定义扩展参数，对于有额外参数配置需要的场景可以通过此字段存储</p>
                            <p>例如，如果需要标注菜单的适用行业为商超便利,标注适用门店类型为单店版（1）</p>
                            <p>可以配置成：{industryType:1,shoptype:2 }</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;"/>
                    </a-popover>
                </a-form-model-item>
    
                <a-row v-for="item in roleTypes" :key="item.roletype" class="roleLine">
                    <a-col :span='4' class="roleType">{{item.roletypename + ':'}}</a-col>
                    <a-col :span='20' id="yxl_checkbox">
                        <a-checkbox-group :options="item.roleChilds" v-model="item.checkedItems" @change="handdleRoleChecked" />
                    </a-col>
                </a-row>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    保存
                </a-button>
            </template>


        </a-modal>
    </div>

</template>
<script>

import MenuModal from './menumodal'

export default {

    data() {
        return {
            actionModalStatus: {
                isShow: false,
            },
            labelCol: {span: 4},
            wrapperCol: {span: 16},
            rules: {
                name: [
                    {required: true, message: '请填写菜单名', trigger: 'blur'},
                ],
                url: [
                    {required: true, message: '请填写URL', trigger: 'blur'},
                ],
                remark: [
                    {required: true, message: '请填写备注', trigger: 'blur'},
                ],
                menucode:[
                    {required: true, message: '请填写Menucode', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            formItemLayout: 'inline',
            modalState: {
                visible: false,
                actionpathMap: [],
                menuData: {}
            },
            urlMap:[],
            isEditblleMenucode:false,
            // dynamicConfig: []
            roleTypes:[],
            urlConfigList:[{
                name:'yxl_web-001'
            },{
                name:'posassistant_app-001'
            },{
                name:'stableposv5_h5-1'
            },{
                name:'zslpv5-1'
            },{
                name:'stableautoposv5-001'
            }]
        };
    },
    computed: {},
    components: {
        MenuModal
    },
    props: {},
    methods: {
        handdleRoleChecked(checkedValues){
            console.log(checkedValues);
            console.log(this.roleTypes);
            console.log(this.modalState.menuData)
        },
        formatZero(num, len) {
            if (String(num).length > len) return num;
            return (Array(len).join(0) + num).slice(-len);
        },
        generateNum(num) {
            let s = [];
            let hexDigits = '0123456789abcdef';
            for (let i = 0; i < num; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            return s.join('');
        },
        generateMenuCode() {
            this.confirmLoading = true
            let value = this.modalState.menuData.platfromcode
            if (this.modalState.menuData.id) {
                value += this.formatZero(this.modalState.menuData.id, 8);
                value += this.generateNum(2)
            } else {
                value += this.generateNum(10)
            }
            this.modalState.menuData.menucode = value.toUpperCase()
            this.confirmLoading = false
        },
        typeOnChange() {
            
            if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3) {
                try {
                    this.urlMap = this.parseMapToArr(JSON.parse(this.modalState.menuData.url))
                } catch (e) {
                    this.urlMap = []
                    console.log(this.modalState.menuData.url)
                }

            } else {
                this.urlMap = []
                console.log(this.modalState.menuData.type)
            }
            
        },
        addMenu() {
            //限制 
            //todo
            if(this.urlMap.length >= this.urlConfigList.length){
                this.message.warn('最多添加' + this.urlConfigList.length + '条')
                return
            }
            let targetIndex = 0;
            this.urlConfigList.forEach((element,index) => {
                let filterList = this.urlMap.filter(item => { return item.name == element.name })
                if(filterList.length == 0){
                    targetIndex = index
                    return
                }
            });
    
            this.urlMap.push(
                {
                    name: this.urlConfigList[targetIndex].name,
                    value:'/'
                }
            )
            this.modalState.menuData.url = JSON.stringify(this.parseArrToMap(this.urlMap));
        },
        addAction() {
            this.actionModalStatus.isShow = true;
        },
        remove(k) {
            this.confirmLoading = true
            this.urlMap = this.urlMap.filter((p_item) => {
                return p_item.name != k.name
            })
            this.modalState.menuData.url = JSON.stringify(this.parseArrToMap(this.urlMap));
            this.confirmLoading = false
        },
        removeAction(k) {
            this.confirmLoading = true
            this.modalState.actionpathMap = this.modalState.actionpathMap.filter((p_item) => {
                return p_item.name != k.name
            })
            // if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3) {
            //     this.modalState.menuData.actionpath = JSON.stringiafy(this.parseArrToMap(this.modalState.menuData.actionpath));
            // }
            
            this.confirmLoading = false
        },

        onNewActionConfig(v) {
            this.confirmLoading = true
            if (v) {
                if (this.modalState.actionpathMap == undefined) {
                    this.modalState.actionpathMap = []
                }
                let filterList = this.modalState.actionpathMap.filter((p_item) => {
                    return p_item.name == v.name
                })
                if (filterList.length > 0) {
                    this.message.error("已存在相同的配置名");
                } else {
                    this.modalState.actionpathMap.push({...v})
                }
            }
            if (this.modalState.type == 2 || this.modalState.type == 3) {
                this.modalState.actionpath = JSON.stringify(this.parseArrToMap(this.modalState.actionpathMap));
            }
            this.actionModalStatus.isShow = false
            this.confirmLoading = false
        },
        onModalInit(item) {
            let that = this;
            let tempActionpathMap = [];
            if(item.type==2 || item.type==3 && item.actionpath){
                try {
                    item.actionpath = JSON.parse(item.actionpath)
                    tempActionpathMap = that.parseMapToArr(item.actionpath)
                } catch (error) {
                    item.actionpath = []
                }
            }
            that.modalState = {
                visible: true,
                title:item.id ? '编辑菜单' :'新增菜单',
                actionpathMap:tempActionpathMap,
                menuData: {
                    id: item.id,
                    pmenucode:item.pmenucode,
                    pid: item.pid,
                    name: item.name,
                    subname: item.subname,
                    type: item.type,
                    url: item.url,
                    menucode: item.menucode,
                    actionpath: item.actionpath,
                    status: item.status,
                    remark: item.remark,
                    ordernum: item.ordernum,
                    icon: item.icon,
                    hookconfig: item.hookconfig,
                    platfromcode: item.platfromcode,
                    level: item.level,
                    createtime: item.createtime,
                    updatetime: item.updatetime,
                    childmenucodelist:item.childmenucodelist,
                    parentmenucodelist:item.parentmenucodelist,
                    addrolecodelist:[],
                    delrolecodelist:[],
                    originrolecodelist:[],
                }
            }


            
            if(!item.menucode){
                that.generateMenuCode();
            }
            //获取菜单角色列表
            this.getMenuRoles();
            that.isEditblleMenucode =  that.modalState.menuData.menucode == ""
            this.typeOnChange();
        },

        //获取菜单角色列表
        getMenuRoles(){
            let that = this;
            that.$store
                .dispatch({
                    type: "ums/rolelist",
                    params: {
                        menucode:that.modalState.menuData.menucode,
                        urlparams:false,
                    }
                })
                .then(res => {
                    if(res.data.success == 1){
                        that.modalState.menuData.originrolecodelist = res.data.data;
                        console.log(that.modalState.menuData.originrolecodelist);
                        that.generateRoleList();
                    }
                });
        },
        //生成角色列表数据
        generateRoleList(){
            //roletype 
            const result = []
            this.modalState.menuData.originrolecodelist.forEach(element => {
                //添加checked字段
                element.checked = element.isauth == '1';
                if(result.filter((item) => { return item.roletype == element.roletype }).length == 0){
                    //组装复选框数据
                    let targetData = this.modalState.menuData.originrolecodelist.filter((nnn) => { return nnn.roletype == element.roletype });
                    let checkedItems = [];
                    for (let index = 0; index < targetData.length; index++) {
                        const titem = targetData[index];
                        titem.label = titem.name;
                        titem.value = titem.rolecode;
                        if(titem.isauth == '1'){
                            checkedItems.push(titem.rolecode)
                        }
                    }
                    result.push({
                        roletype:element.roletype,
                        roletypename:element.roletypename,
                        roleChilds: targetData,
                        checkedItems:checkedItems,
                    })
                }
            });
            this.roleTypes = result;
        },
        parseArrToMap(arr) {
            let map = {}
            for (let index in arr) {
                let item = arr[index]
                map[item.name] = item.value
            }
            return map
        },
        parseMapToArr(map) {
            let arr = []
            for (let key in map) {
                arr.push({"name": key, "value": map[key]})
                // let item = arr[index]
                // map[item.name] = item.value
            }
            return arr
        },
        handleMenuRoleData(){
            //组织菜单权限
            this.modalState.menuData.addrolecodelist = [];
            this.modalState.menuData.delrolecodelist = [];
            this.roleTypes.forEach(element => {
                for (let index = 0; index < element.roleChilds.length; index++) {
                    const child = element.roleChilds[index];
                    if(child.isauth == '1'){
                        //之前已经选中，检查有没有删除
                        if(element.checkedItems.indexOf(child.rolecode) == -1){
                            this.modalState.menuData.delrolecodelist.push(child.rolecode)
                        }
                    }
                    else{
                        //之前未选中
                        if(element.checkedItems.indexOf(child.rolecode) != -1){
                            this.modalState.menuData.addrolecodelist.push(child.rolecode)
                        }
                    }
                }
            });
            this.modalState.menuData.addrolecodelist = JSON.stringify(this.modalState.menuData.addrolecodelist);
            this.modalState.menuData.delrolecodelist = JSON.stringify(this.modalState.menuData.delrolecodelist);

            this.modalState.menuData.childmenucodelist = JSON.stringify(this.modalState.menuData.childmenucodelist);
            this.modalState.menuData.parentmenucodelist = JSON.stringify(this.modalState.menuData.parentmenucodelist);
            this.modalState.menuData.originrolecodelist = undefined;


        },
        handleOk() {
            let that = this
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(that.modalState.menuData);
                    //组织菜单权限
                    that.handleMenuRoleData();
                    that.confirmLoading = true;
                    if (that.modalState.menuData.type == 2 || that.modalState.menuData.type == 3) {
                        that.modalState.menuData.url = JSON.stringify(that.parseArrToMap(that.urlMap));
                        that.modalState.menuData.actionpath = JSON.stringify(that.parseArrToMap(that.modalState.actionpathMap));
                        if(that.urlMap.length == 0){
                            this.message.error('路径URL必填')
                            that.confirmLoading = false;
                            return
                        }
                    }
                    // let arr = that.parseMapToArr(JSON.parse(that.modalState.url))
                    // console.log(arr)
                    if (that.modalState.menuData.id) {
                        //编辑
                        that.$store
                            .dispatch({
                                type: "ums/updateMenuConfig",
                                params: this.modalState.menuData
                            })
                            .then((response) => {
                                console.log(response)
                                that.modalState.visible = false;
                                that.$emit('onModalHide');
                                that.confirmLoading = false;
                            });
                    } else {
                        //新增
                        that.$store
                            .dispatch({
                                type: "ums/insertMenuConfig",
                                params: this.modalState.menuData
                            })
                            .then((response) => {
                                console.log(response)
                                that.modalState.visible = false;
                                that.$emit('onModalHide');
                                that.confirmLoading = false;
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel(e) {
            e.preventDefault()
            this.resetForm();
            this.modalState.visible = false;
            this.$emit('onModalHide');
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    width: 100%;
}
.roleItem{
    text-align: center;
}
.roleType{
    color: rgba(0, 0, 0, 0.85);
    text-align: right;
    padding-right: 10px;
}
.roleLine{
    margin-bottom: 20px;
}

.urlItemInput{
    width: calc(50% - 40px);
}
</style>

<style>
#yxl_checkbox .ant-checkbox-group-item{
    min-width: 120px;
}
</style>
